<template>
	<tbody>
        <tr v-for="list in accountlist" v-if="$route.name == 'fxView.dashboard'">
            <td class="p-0 border-0" colspan="6" >
                <table class="inntebbel cloud">  
                    <tbody>
                        <tr>
                            <td class="text-center"><img class="d-block" width="24px" :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" alt="Icon"></td>
                            <td>{{list.account_id}}</td>
                            <td>{{list.leverage}}</td>
                            <td> 
                                <span class="d-flex align-items-center">
                                    <img class="mr-1 rounded-circle" width="24px" :src="'../../../../static/fxView/images/'+$env_var.currencyImages[list.currency.toUpperCase()]" alt="Icon">
                                    {{list.currency}}
                                </span>
                            </td>
                            <td v-if="listType == '1'">
                                <router-link class="createNew fund_btn greenBG" v-if="parseInt(list.demo_live) == 1" :to="{name: 'accountfunding' , params: {'page':'deposit', 'account_id':list.account_id , 'act_account_id' : list.act_account_id, 'currency': list.currency.toUpperCase()}}" @click.native="handleAddFund('CP+Dashboard+Fund')">{{$t('acclist_fund')}}</router-link>
                            </td>
                            <td align="center" @click.prevent="$parent.selectTradingAccountFunc(list)">
                                <a class="arrowClick" :class="(list.id == $parent.id)?'active':' '" href="#"><feather class="rotateCell" type="chevron-down" size="20px"></feather></a> 
                            </td>
                        </tr>
                        <tr class="showDiv"  v-if="list.id == $parent.id">
                            <td class="p-0  border-0" :colspan="(listType == '1')?6:5">
                                <span class="innerloader"><complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading></span>
                                <open-close-trade v-if="accountDetails != '' && Object.keys(accountDetails).length > 0"></open-close-trade>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        <!-- {{ accountlist }} ==== -->
        <tr class="selectHere" v-for="(list,index) in accountlist" v-if="($route.name == 'account' || ($route.name == 'social_trade' && list.platform.toUpperCase() == 'ZULU') || ($route.name == 'social_trade' && parseInt(list.is_ib_mamm) === 1)) && checkPagination(index)">
            <td>{{list.account_id}}</td>
            <td><img :src="'../../../../static/fxView/images/'+$env_var.currencyImages[list.currency.toUpperCase()]" class="data_currency rounded-circle"></td>
            <td>{{list.platform}}</td>
            <td v-html="(parseInt(list.demo_live) == 0)? 'demo' :'live'"></td>
            <td>{{parseInt(list.is_ib_mamm) === 1 ? $t('mampamm_account_account_type') : list.account_type}}</td>
            <td>{{list.leverage}}</td>
            <td width="120">
                <div class="d-flex align-items-center rr"> 
                    <router-link :to="{name: 'accountfunding' , params: {'page':'deposit', 'account_id':list.account_id , 'act_account_id' : list.act_account_id, 'currency': list.currency.toUpperCase()}}" class="prism_btn titleBG btn_xs" v-if="listType != 'demo' && checkROll('deposits') && ($route.name == 'social_trade' && list.platform.toUpperCase() == 'ZULU')" @click.native="handleAddFund('CP+Zulutrade+Add+Funds')">{{$t('acclist_addFund')}}</router-link>
                    <router-link :to="{name: 'accountfunding' , params: {'page':'deposit', 'account_id':list.account_id , 'act_account_id' : list.act_account_id, 'currency': list.currency.toUpperCase()}}" class="prism_btn titleBG btn_xs" v-if="listType != 'demo' && checkROll('deposits') && ($route.name == 'social_trade' && parseInt(list.is_ib_mamm) === 1)">{{$t('acclist_addFund')}}</router-link>

                    <router-link :to="{name: 'accountfunding' , params: {'page':'deposit', 'account_id':list.account_id , 'act_account_id' : list.act_account_id, 'currency': list.currency.toUpperCase()}}" class="prism_btn titleBG btn_xs" v-else-if="listType != 'demo' && checkROll('deposits') && $route.name == 'account'" @click.native="handleAddFund('CP+Account+Add+Funds')">{{$t('acclist_addFund')}}</router-link>
                    <!-- add deposit demo Section -->
                    <a href="#" class="prism_btn titleBG btn_xs fundNow" @click.prevent="addFund(list.account_id,list.act_account_id)" v-else-if="listType == 'demo'" >{{$t('acclist_addFund')}}</a>
                    <div class="costompopup pop_xs fundNow1 DemoCustom" v-if="demoAcountDeposit && account_id == list.account_id">
                        <div class="whiteBG costompopupBox ">
                            <div class="loader" v-if="depositAddLoader"></div> 
                            <div class="modal-header border-0 pt-3 pl-3 position-relative"> 
                                <h3 class="modal-title" v-if="fund_msz != ''">{{$t('acclist_addFundTo')}} <strong>{{list.account_id}}</strong> {{$t('acclist_tradingId')}}</h3>
                                <h3 class="modal-title" v-else>{{$t('acclist_addingFundTo')}} <strong>{{list.account_id}}</strong> {{$t('createzullu_tradingAcc')}}</h3>
                                <button type="button" class="close" @click.prevent="closeAddFund()">&times;</button>
                            </div>
                            <div class="modal-body p-3" >  
                                <div class="text-center mb-3" v-if="fund_msz != ''">
                                    <div class="thumb mb-2">
                                        <img src="../../../../../static/fxView/images/check.svg" alt="success" width="50" height="50" v-if="fund_msz_type == 'success'">
                                        <img src="../../../../../static/fxView/images/cross.svg" alt="success" width="50" height="50" v-if="fund_msz_type == 'error'">
                                    </div>
                                    <h4 class="green" v-if="fund_msz_type == 'success'">{{$t('acclist_fund_msz')}}</h4>
                                    <h4 class="red" v-else>{{$t('acclist_fund_mszErr')}}</h4>
                                </div>
                                <div v-else>
                                    <input type="text" :placeholder="$t('enterAmount')" v-model="amount" v-validate="{ required: true, numeric : true }" name="amount" class=" form-control"  :class="{ 'is-invalid': submitted && errors.has('amount') }" ref="amountInput"  >
                                    <div class="text-center pt-3 mb-3" >
                                        <a href="#" class="prism_btn btn_xs" @click.prevent="submit()">{{$t('acclist_addFund')}}</a>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="position-relative ml-3">
                        <span class="tableoption dotAreaForButton" @click.prevent="$parent.detailDiv(index,'buttons',list.account_id,list.act_account_id)"><feather type="more-horizontal" size="1rem"></feather></span>                                
                        <div class="tablefilter box-shadow"  :id="'buttons'+index" v-if="parseInt($parent.showButtonDetailInfo) == index">
                             <ul>
                                <li v-if="listType != 'managed'">
                                    <router-link :to="{name: 'fxView.changeLeverage' , params: { 'account_id':list.account_id, 'leverage':list.leverage, 'act_account_id' : list.act_account_id , 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('acclist_changeLeverage')}}</router-link>
                                </li>
                                <li>
                                    <router-link :to="{name: 'fxView.changePassword' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('acclist_changePassword')}}</router-link>
                                </li>
                                <li v-if="listType != 'demo'">
                                    <router-link :to="{name: 'fxView.internalTransfer' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform , 'from_currency': list.currency}}">{{$t('acclist_internalTransfer')}}</router-link>
                                </li>
                                <li v-if="listType != 'managed'">
                                    <a title="Act Web Trader Live" href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245" target="_blank" v-if="(list.platform == 'ACT' || list.platform == 'ACT-ZULU') && listType == 'live'">{{$t('acclist_tradeNow')}}</a>
                                    <a title="Act Web Trader Demo" href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" target="_blank" v-if="(list.platform == 'ACT' || list.platform == 'ACT-ZULU') && listType == 'demo'">{{$t('acclist_tradeNow')}}</a>

                                    <a title="web_trader" :href="`${$env_var.downloadPlatformLink1.MT5.webdemoAccount}${list.account_id}&server=FXView-Demo`" target="_blank" v-if="(list.platform != 'ACT' && list.platform != 'ACT-ZULU' && list.platform.toUpperCase() !== 'MT4') && listType == 'demo'">{{$t('acclist_tradeNow')}}</a>
                                    <a title="web_trader" :href="`${$env_var.downloadPlatformLink1.MT5.webliveAccount}${list.account_id}&server=FXView-Live`" target="_blank" v-if="(list.platform != 'ACT' && list.platform != 'ACT-ZULU' && list.platform.toUpperCase() !== 'MT4') && listType == 'live'">{{$t('acclist_tradeNow')}}</a>

                                    <router-link :to="{path: $env_var.downloadPlatformLink1.MT4.webTraderInternalLink , query: { 'platform': 'MT4', 'id': list.account_id }}" v-if="(list.platform.toUpperCase() == 'MT4')">{{$t('acclist_tradeNow')}}</router-link>
                                </li>
                                <li v-if="listType == 'managed'">
                                    <router-link to="/detach-account">{{$t('acclist_detachAcc')}} </router-link>
                                </li>
                             </ul>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</template>
<script>
    import open_close_trade from './open_close_trade_list'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Account-list-table',
        mixins: [fxViewMixins],
        data() {
            return {

                amount : '',
                submitted : false,
                demoAcountDeposit : false,
               
                 depositAddLoader : false,
                fund_msz : '',
                fund_msz_type : '',
            }
        },
        props:{
        	accountlist:{ default:[] },
            pageLimit:{ default:'' },
            page:{ default:'' },
		    pageLoader:{ default:false },
            listType:{ default:'live' }
        },
        components: {
            openCloseTrade : open_close_trade
        },
        methods:{
            getTraderPath(item){
                if(parseInt(item.demo_live) == 1){
                    return (parseInt(item.account_id) > 3000001 && parseInt(item.account_id) < 3004999)?'/web-trade-link':$env_var.downloadPlatformLink1.MT4.webTraderInternalLink
                }else if(parseInt(item.demo_live) == 0){
                    return (parseInt(item.account_id) > 4000003 && parseInt(item.account_id) < 4002499)?'/web-trade-link':$env_var.downloadPlatformLink1.MT4.webTraderInternalLink
                }else{
                    return '/web-trade-link'
                }
            },
            checkPagination(index){
                if(this.page){
                    return (index < parseInt(this.page)*parseInt(this.pageLimit) && index >= (parseInt(this.page)-1)*parseInt(this.pageLimit))
                }else{
                   return true 
                }
            },
            reset(){
                this.submitted = false
                this.amount = ''
            },
            closeAddFund(){
                this.demoAcountDeposit = false ;
                this.fund_msz = '';
                this.amount = ''
            },
            handleAddFund(event) {
                this.$trackEvent(event);
            },
            addFund(account_id,act_account_id){
                this.$trackEvent('CP+Account+Add+Funds')   
                this.account_id = account_id
                this.act_account_id = act_account_id
                this.demoAcountDeposit = true
            },
            submit(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        if(parseInt(this.amount) > 100000){
                            this.fund_msz_type = 'error'
                            this.fund_msz = _that.$t('allowDeposit1lac')
                        }else{
                            let input_json={
                                'globalParams' :{
                                    'account_id' : _that.account_id ,
                                    'act_account_id' : _that.act_account_id,
                                    'amount' : _that.amount ,
                                    'comment' : 'deposit'
                                },
                                'localParams' :{ "parameter" : _that , 'page' : 'man_account'}
                            }
                            _that._runDemoDeposit(input_json)
                        }
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
         
           
        	
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/tradingAccounts/account-list-table.vue